import { render, staticRenderFns } from "./TaxInvoiceList.vue?vue&type=template&id=60bdcbf9&scoped=true"
import script from "./TaxInvoiceList.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceList.vue?vue&type=style&index=0&id=60bdcbf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdcbf9",
  null
  
)

export default component.exports